<div class="c-checkbox">
  <label class="c-label"
    for="terms-checkbox">
    <input id="terms-checkbox"
      type="checkbox"
      name="terms"
      [ngModel]="isUserConfirmTerms"
      (change)="toggleConfirmTerms($event)"
      [attr.disabled]="disabled || null"
      [attr.aria-required]="true"
      [attr.aria-checked]="isUserConfirmTerms"
      [attr.aria-label]="isUSAccount ? resources?.UploadConsentUSSubmitTermsTitle : resources.UploadSubmitTermsTitle"
      [attr.title]="isUSAccount ? resources?.UploadConsentUSSubmitTermsTitle : resources.UploadSubmitTermsTitle" />
    <span class="checkbox-text"
      role="none"
      [innerHTML]="isUSAccount ? resources?.UploadConsentUSSubmitTerms : resources?.ViUploadConsentSubmitTerms">
    </span>
  </label>
</div>
